var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgL04 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 354.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-1323.00, 0.00)",
    id: "L4_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334.36,152.32 C1331.58,157.70 1327.68,171.77 1326.95,179.06 C1326.58,182.96 1326.57,190.32 1326.97,194.51 C1327.81,202.85 1332.31,220.33 1335.51,228.43 C1338.19,234.81 1344.44,248.26 1348.01,255.33 C1351.88,262.63 1360.46,277.86 1364.94,285.34 C1369.42,292.52 1378.43,306.03 1382.95,312.35 C1389.93,321.64 1397.00,329.99 1403.91,336.85 C1409.87,342.73 1421.93,352.73 1427.97,356.80 C1434.06,360.88 1447.01,367.51 1453.90,370.08 C1461.85,373.02 1474.02,375.78 1482.69,376.64 C1490.18,377.36 1505.95,377.39 1514.24,376.70 C1522.67,375.98 1538.68,373.17 1546.38,371.06 C1553.77,369.01 1567.38,363.81 1575.20,359.52 C1581.83,355.87 1594.49,347.28 1600.52,342.35 C1606.65,337.32 1617.90,326.31 1623.11,320.22 C1628.31,314.11 1638.67,299.57 1641.84,293.74 C1646.02,285.92 1652.29,272.19 1655.25,264.36 C1657.82,257.54 1663.22,239.83 1665.42,231.66 C1667.38,223.76 1670.54,208.78 1671.74,201.70 C1673.09,192.59 1673.74,178.13 1673.22,170.40 C1672.66,162.66 1669.59,148.78 1666.65,142.74 C1665.03,139.48 1660.84,132.95 1658.27,129.68 C1652.53,122.43 1641.12,112.70 1635.92,108.87 C1630.71,105.05 1615.85,95.62 1608.22,91.19 C1592.19,82.50 1556.60,64.75 1551.58,62.73 C1543.53,59.51 1526.81,54.53 1520.78,53.56 C1514.97,52.66 1502.08,53.61 1493.90,55.52 C1487.03,57.16 1472.72,62.43 1465.90,65.22 C1451.61,71.42 1419.37,87.64 1404.81,95.35 C1398.15,99.01 1387.81,104.73 1376.34,112.30 C1369.10,117.32 1354.74,128.09 1351.00,131.49 C1345.84,136.23 1336.96,147.35 1334.36,152.32 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL04, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L-04.b83d5467.svg";
export { ForwardRef as ReactComponent };